import React from "react";

const ItemRequestsTable = ({ itemRequests }) => {
  return (
    <div className="table-responsive">
      <table className="table table-hover">
        <thead>
          <tr>
            <th>ID</th>
            <th>Date</th>
            <th>Purpose</th>
            <th>Item</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          {itemRequests.map((itemRequest, key) => (
            <tr key={key}>
              <td>{itemRequest.id}</td>
              <td>
                <h6 className="m-0">
                  {new Date(itemRequest.date).toLocaleDateString("en-UK")}
                </h6>
              </td>
              <td>
                <h6 className="m-0">{itemRequest.purpose}</h6>
              </td>
              <td>
                <h6 className="m-0">{itemRequest.item_name}</h6>
              </td>
              <td>
                <h6 className="m-0">{itemRequest.quantity}</h6>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ItemRequestsTable;
